import { render, staticRenderFns } from "./toExamine.vue?vue&type=template&id=4108a044&scoped=true&"
import script from "./toExamine.vue?vue&type=script&lang=js&"
export * from "./toExamine.vue?vue&type=script&lang=js&"
import style0 from "./toExamine.vue?vue&type=style&index=0&id=4108a044&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4108a044",
  null
  
)

export default component.exports